import React from "react";
import Banner from "../components/trust/Banner";
import CommonContainer from "../components/shared/CommonContainer";
import {
  Box,
  Flex,
  Heading,
  Image,
  SimpleGrid,
  Stack,
  Text,
} from "@chakra-ui/react";

export default function TrustPage() {
  return (
    <CommonContainer>
      <Banner />
      <Flex
        gap={{ base: 10, md: 20, xl: 40 }}
        flexDir={{ base: "column", lg: "row" }}
      >
        <Stack w={{ lg: "40%" }} gap={5}>
          <Heading
            fontSize={{ base: 24, md: 40 }}
            fontWeight={"semibold"}
            maxWidth="390px"
          >
            Getting To Know Your Sellers Is Easy
          </Heading>
          <Text fontSize={{ lg: "21px" }} color="gray.400">
            Lorem Ipsum is simply dummy text of the printing and typesetting
            industry. Lorem Ipsum has been the industry's standard dummy text
            ever since the 1500s, when an unknown
          </Text>
          <Box>
            <Heading fontSize={"22px"} fontWeight={"semibold"}>
              Seller Ratings
            </Heading>
            <Text color="gray.400" fontSize={"19px"} py={3}>
              Lorem Ipsum is simply dummy text of the printing and typesetting
            </Text>
          </Box>
          <Box>
            <Heading fontSize={"22px"} fontWeight={"semibold"}>
              Buyer Feedback
            </Heading>
            <Text color="gray.400" fontSize={"19px"} py={3}>
              Lorem Ipsum is simply dummy text of the printing and typesetting
            </Text>
          </Box>
        </Stack>
        <Stack w={{ lg: "60%" }}>
          <Image src="/images/trust-matters/section.png" />
        </Stack>
      </Flex>
      <Stack gap={4} alignItems="center" my={20}>
        <Heading align="center" fontWeight={"semibold"} fontSize="31px">
          Buy And Sell, Worry Free
        </Heading>
        <Text
          align="center"
          color="gray.400"
          fontSize={{ lg: "19px" }}
          maxW="750px"
        >
          With millions of orders taking place, Fiverr uses the latest high tech
          anti-fraud and data security measures to keep your transactions and
          data safe.
        </Text>
        <SimpleGrid
          columns={{ base: 1, md: 2, lg: 3 }}
          py={10}
          w="full"
          gap={10}
        >
          <Stack alignItems="center" gap={4}>
            <Image src="/images/trust-matters/personal.png" w="80px" />
            <Heading fontSize="27px" fontWeight={"semibold"} textAlign="center">
              Personal Details
            </Heading>
            <Text
              maxW="350px"
              fontSize={{ base: "16px", lg: "24px" }}
              color="gray.400"
              align="center"
            >
              Fiverr values your privacy. Your data is secure at all times and
              we'll never share your personal information with third parties.
            </Text>
          </Stack>
          <Stack alignItems="center" gap={4}>
            <Image src="/images/trust-matters/payment.png" w="80px" />
            <Heading fontSize="27px" fontWeight={"semibold"} textAlign="center">
              Safe Payments
            </Heading>
            <Text
              maxW="350px"
              fontSize={{ base: "16px", lg: "24px" }}
              color="gray.400"
              align="center"
            >
              All transactions are conducted on the Fiverr platform. Whether a
              buyer uses a credit card, PayPal or other form of payment, we
              handle everything, and ensure the security of your personal
              details. Fiverr is committed to the highest security standards as
              a Level 1 PCI-DSS service provider.
            </Text>
            <Image src="/images/trust-matters/pci.png" />
          </Stack>
          <Stack alignItems="center" gap={4}>
            <Image src="/images/trust-matters/communication.png" w="80px" />
            <Heading fontSize="27px" fontWeight={"semibold"} textAlign="center">
              Secure Communications
            </Heading>
            <Text
              maxW="350px"
              fontSize={{ base: "16px", lg: "24px" }}
              color="gray.400"
              align="center"
            >
              You can safely communicate and exchange files with any Seller on
              Fiverr through our secure messaging system.
            </Text>
          </Stack>
        </SimpleGrid>
        <Flex
          borderRadius={60}
          py={2}
          pl={2}
          bgGradient="linear(to-b,#0079BC,#74C7F5)"
          gap={4}
          alignItems="center"
          pr={10}
          my={10}
        >
          <Image
            src="/images/trust-matters/24hr.png"
            maxW={{ base: "100px", md: "100%" }}
          />
          <Text
            color="white"
            maxW="780px"
            fontSize={{ base: "10px", md: "18px", lg: "24px" }}
          >
            We're here to help with any issues you may have, with a friendly
            customer support team at your service 24/7.
          </Text>
        </Flex>
      </Stack>
    </CommonContainer>
  );
}
